const initState = {
  promotionPlanTab: null // 推广计划选项
}
const state = {
  ...initState,
  initState() {
    return initState
  }
}
const mutations = {
  // 获取推广计划选项
  getPromotionPlanTab(state, data) {
    state.promotionPlanTab = data
    console.log(state.promotionPlanTab, '我是promotionPlanTab选项')
  }
}
export default {
  namespaced: true,
  state,
  mutations
}
